import { Link } from "@/components/link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";
import { memo } from "react";
import { useMatch } from "react-router-dom";

interface MobileFooterButtonProps {
  icon: LucideIcon;
  title?: string;
  url?: string;
}

const MobileFooterButtonContent = ({
  title,
  icon: Icon,
}: MobileFooterButtonProps) => (
  <>
    <Icon className="!size-8 mb-0" />
    <label className="text-[9px] truncate w-full text-center">{title}</label>
  </>
);

export const MobileFooterButton = memo(
  ({ url, icon, title, ...props }: MobileFooterButtonProps) => {
    const match = useMatch(url ?? "");
    const hasUrl = url !== undefined;
    return (
      <Button
        asChild={hasUrl}
        variant="ghost"
        className={cn(
          "flex flex-col gap-0 justify-center h-14 p-1 overflow-visible",
          {
            "bg-slate-200": match !== null,
          },
        )}
        {...props}
      >
        {hasUrl ? (
          <Link to={url}>
            <MobileFooterButtonContent title={title} icon={icon} />
          </Link>
        ) : (
          <MobileFooterButtonContent title={title} icon={icon} />
        )}
      </Button>
    );
  },
);
